import { useToast } from '@chakra-ui/react'
import React from 'react'

export default function ShowToastr({title, description, status, isClosable}) {
    const toast = useToast()
    return toast({title: title, description: description, status: status, isClosable: !!isClosable})
}
